// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_List from "../../../../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Timestamp$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as DriverLeadPageViewStore from "../view-store/DriverLeadPageViewStore.bs.js";
import * as DriverPartnerPageAssestsManager from "../../assets/DriverPartnerPageAssestsManager.bs.js";

function getDriverStatus(status) {
  switch (status) {
    case 0 :
        return DriverLeadPageViewStore.doc_verification_ticket_status;
    case 1 :
        return DriverLeadPageViewStore.rejected_ticket_status;
    case 2 :
        return DriverLeadPageViewStore.verfied_ticket_status;
    default:
      return "";
  }
}

function driverLeadPageVM(responseData) {
  var getLeadData = Belt_List.get(responseData.data, 0);
  if (getLeadData !== undefined) {
    return {
            lead_id: getLeadData.lead_id,
            current_onboarding_status: getDriverStatus(getLeadData.status_info.status),
            onboarding_status_timestamp: Timestamp$Catalyst.toString(getLeadData.status_info.last_updated_at, "DD/MM/YYYY, HH:mm A")
          };
  } else {
    return {
            lead_id: "",
            current_onboarding_status: "",
            onboarding_status_timestamp: ""
          };
  }
}

function getVehicleBodyType(bodyType) {
  if (bodyType !== undefined) {
    return bodyType.toLowerCase();
  } else {
    return "NA";
  }
}

function getListOfBasicLeadDetails(responseData) {
  var getLeadData = Belt_List.get(responseData.data, 0);
  if (getLeadData === undefined) {
    return /* [] */0;
  }
  var getOwnerInfo_img_path = DriverPartnerPageAssestsManager.getImage("owner-info-icon.svg");
  var getOwnerInfo_label_value_list = {
    hd: [
      DriverLeadPageViewStore.owner_name_text,
      getLeadData.owner_info.name
    ],
    tl: {
      hd: [
        DriverLeadPageViewStore.owner_phone_text,
        getLeadData.owner_info.mobile
      ],
      tl: /* [] */0
    }
  };
  var getOwnerInfo = {
    header: "Owner Info",
    img_path: getOwnerInfo_img_path,
    label_value_list: getOwnerInfo_label_value_list
  };
  var getVehicleIinfo_img_path = DriverPartnerPageAssestsManager.getImage("vehicle-info-icon.svg");
  var getVehicleIinfo_label_value_list = {
    hd: [
      DriverLeadPageViewStore.vehicle_type_text,
      getLeadData.vehicle_info.vehicle_type
    ],
    tl: {
      hd: [
        DriverLeadPageViewStore.model_text,
        getLeadData.vehicle_info.model
      ],
      tl: {
        hd: [
          DriverLeadPageViewStore.body_type_text,
          getVehicleBodyType(getLeadData.vehicle_info.body_type)
        ],
        tl: {
          hd: [
            DriverLeadPageViewStore.rc_number_text,
            getLeadData.vehicle_info.number
          ],
          tl: {
            hd: [
              DriverLeadPageViewStore.driver_location_text,
              getLeadData.basic_info.city_name
            ],
            tl: /* [] */0
          }
        }
      }
    }
  };
  var getVehicleIinfo = {
    header: "Vehicle Info",
    img_path: getVehicleIinfo_img_path,
    label_value_list: getVehicleIinfo_label_value_list
  };
  var getDriverInfo_img_path = DriverPartnerPageAssestsManager.getImage("driver-info-icon.svg");
  var getDriverInfo_label_value_list = {
    hd: [
      DriverLeadPageViewStore.driver_name_text,
      getLeadData.driver_info.name
    ],
    tl: {
      hd: [
        DriverLeadPageViewStore.contact_number_text,
        getLeadData.driver_info.mobile
      ],
      tl: /* [] */0
    }
  };
  var getDriverInfo = {
    header: "Driver Info",
    img_path: getDriverInfo_img_path,
    label_value_list: getDriverInfo_label_value_list
  };
  return {
          hd: getOwnerInfo,
          tl: {
            hd: getVehicleIinfo,
            tl: {
              hd: getDriverInfo,
              tl: /* [] */0
            }
          }
        };
}

function getHeaderDetails(lead_id, dashboard_flow, onboarding_status, timestamp) {
  return {
          hd: [
            DriverLeadPageViewStore.lead_id_info_title,
            lead_id
          ],
          tl: {
            hd: [
              DriverLeadPageViewStore.dashboard_flow_title,
              dashboard_flow
            ],
            tl: {
              hd: [
                DriverLeadPageViewStore.onboarding_status_title,
                onboarding_status
              ],
              tl: {
                hd: [
                  DriverLeadPageViewStore.timestamp_title,
                  timestamp
                ],
                tl: /* [] */0
              }
            }
          }
        };
}

function getDashboardFlow(responseData) {
  var getLeadData = Belt_List.get(responseData.data, 0);
  if (getLeadData !== undefined && getLeadData.status_info.waitlist_reason !== undefined) {
    return /* NewFlow */1;
  } else {
    return /* OldFlow */0;
  }
}

function getLeadStatus(dashboard_flow, responseData) {
  var getLeadData = Belt_List.get(responseData.data, 0);
  if (getLeadData === undefined) {
    return "";
  }
  if (!dashboard_flow) {
    return getDriverStatus(getLeadData.status_info.status);
  }
  var val = getLeadData.status_info.status;
  if (val === 1 || val === 2) {
    return getDriverStatus(val);
  } else if (val !== 0) {
    return "";
  } else {
    return Belt_Option.mapWithDefault(getLeadData.status_info.waitlist_reason, "", (function (waitlist_reason) {
                  if (waitlist_reason !== 0) {
                    if (waitlist_reason !== 1) {
                      return "";
                    } else if (getLeadData.status_info.is_waitlisted === true) {
                      return DriverLeadPageViewStore.shortlist_ticket_status;
                    } else {
                      return DriverLeadPageViewStore.doc_verification_ticket_status;
                    }
                  } else if (getLeadData.status_info.is_waitlisted === true) {
                    return DriverLeadPageViewStore.waitlist_ticket_status;
                  } else {
                    return "";
                  }
                }));
  }
}

function getHeaderValueClassname(label, value) {
  if (label === DriverLeadPageViewStore.dashboard_flow_title) {
    return " journey-value";
  } else if (label === DriverLeadPageViewStore.onboarding_status_title) {
    return " status-value" + (
            value === DriverLeadPageViewStore.waitlist_ticket_status ? " waitlist" : (
                value === DriverLeadPageViewStore.shortlist_ticket_status ? " shortlist" : (
                    value === DriverLeadPageViewStore.doc_verification_ticket_status ? " doc_verify" : (
                        value === DriverLeadPageViewStore.verfied_ticket_status ? " verified" : (
                            value === DriverLeadPageViewStore.rejected_ticket_status ? " rejected" : ""
                          )
                      )
                  )
              )
          );
  } else {
    return "";
  }
}

export {
  getDriverStatus ,
  driverLeadPageVM ,
  getVehicleBodyType ,
  getListOfBasicLeadDetails ,
  getHeaderDetails ,
  getDashboardFlow ,
  getLeadStatus ,
  getHeaderValueClassname ,
  
}
/* Timestamp-Catalyst Not a pure module */
